import { SetStateAction, useState } from 'react';

export type NoteAttachmentDataType = {
  fileValidationStatus?: string;
  isValidFile?: boolean;
  name: string;
  url: string;
};

export type NoteState = {
  showNoteAttachmentModal: NoteAttachmentDataType | null;
  setShowNoteAttachmentModal: React.Dispatch<
    SetStateAction<NoteAttachmentDataType>
  >;
};

const useNoteAttachmentModal = (): NoteState => {
  // TODO when the note API that gets fetched as a result of this is moved to RTK query, we can remove this state and use cacheTags
  const [showNoteAttachmentModal, setShowNoteAttachmentModal] =
    useState<NoteAttachmentDataType | null>(null);

  return {
    setShowNoteAttachmentModal,
    showNoteAttachmentModal,
  };
};

export default useNoteAttachmentModal;
